export enum ErrorsMessages {
  PasswordTokenExpiredOrInvalid = 'Password validation token is expired or invalid',
  RefreshTokenExpired = 'Refresh token is invalid or expired.',
  IncorrectEmailOrPassword = 'Incorrect email or password.',
}
